import {
  HomeOutlined,
  InsertRowLeftOutlined,
  ProjectOutlined,
  DeleteTwoTone,
  EditTwoTone,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Popconfirm,
  Radio,
  Breadcrumb,
} from "antd";

import {
  addAddressApi,
  deleteAddressApi,
  geAddressApi,
  updateAddressApi,
} from "../../Features/Address/Address";
import {
  addCouponCodeApi,
  getCouponCodeApi,
} from "../../Features/Setting/Setting";
import { routes } from "../../Routes/Routes";
import TextArea from "antd/es/input/TextArea";
import { addOrderApi } from "../../Features/Order/Order";
import { geCartListApi } from "../../Features/AddCart/AddCart";
import { getProfileApi, setCartCount } from "../../Features/User/User";

import { getVariantTags } from "../../utils/cartVariants";
import { getRetailerVatSettings, refreshRetailerSettings } from "../../utils/vatHelper";
import styles from "./index.module.scss";

function AddressDropdown({ items, selectedIndex, onSelect, styles }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const formatLabel = (item) => {
    const type = item?.Type ? `[${item.Type}] ` : "";
    const name = item?.Name || "";
    const city = item?.City || "";
    return `${type}${name} — ${city}`;
  };

  const selected = items[selectedIndex];

  return (
    <div className={styles.customSelect} ref={ref}>
      <button type="button" className={styles.customSelectTrigger} onClick={() => setOpen(!open)}>
        <span className={styles.customSelectText}>{formatLabel(selected)}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" style={{ flexShrink: 0, transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
          <path d="M1 1l4 4 4-4" stroke="#999" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && (
        <div className={styles.customSelectDropdown}>
          {items.map((item, index) => (
            <button
              type="button"
              key={item?._id || index}
              className={`${styles.customSelectOption} ${index === selectedIndex ? styles.customSelectOptionActive : ""}`}
              onClick={() => { onSelect(index); setOpen(false); }}
            >
              <span className={styles.customSelectOptionType}>{item?.Type || "Other"}</span>
              <span className={styles.customSelectOptionName}>{item?.Name}</span>
              <span className={styles.customSelectOptionCity}>{item?.City}{item?.Pincode ? `, ${item.Pincode}` : ""}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function Summery() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const addressList = useSelector((state) => state.address?.addressData);
  const userToken = useSelector((state) => state.user?.token);
  const cartlist = useSelector((state) => state.addCart?.cartListData);
  const couponListData = useSelector((state) => state.setting?.couponCodeData);
  const isOrderLoading = useSelector((state) => state.order?.isOrderLoading);
  const loaderAddress = useSelector((state) => state.address?.isAddressLoading);
  const loaderCoupon = useSelector((state) => state.setting?.settingLoading);
  const applyCoupon = useSelector((state) => state.setting?.couponData);

  const [Add, setAdd] = useState();
  const [editId, setEditId] = useState("");
  const [couponCode, setCouponCode] = useState();
  const [addType, setAddType] = useState("");
  const [couponId, setCouponId] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCoupon, setIsModalCoupon] = useState(false);
  const [couponName, setCouponName] = useState("");
  const [couponPrice, setCouponPrice] = useState(0);
  const [indexSelect, setIndexSelect] = useState(0);
  const [vatSettings, setVatSettings] = useState(getRetailerVatSettings());

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(geAddressApi(userToken));
    dispatch(geCartListApi(userToken));
    dispatch(getProfileApi(userToken));
    dispatch(getCouponCodeApi(userToken));
    refreshRetailerSettings().then(() => setVatSettings(getRetailerVatSettings()));
  }, [couponPrice, applyCoupon]);

  const handleAddreesRemove = (item) => {
    dispatch(deleteAddressApi(item?._id, userToken));
  };

  const handleAddressUpdate = (item) => {
    setEditId(item._id);
    form.setFieldsValue({
      name: item.Name,
      housenumber: item.House,
      landmark: item.landmark,
      address: item.Full_Address,
      state: item.State,
      city: item.City,
      pincode: item.Pincode,
    });
    setAddType(item.Type);
    setIsModalOpen(true);
    setIsEdit(true);
  };

  const handleAddressSubmit = (value) => {
    if (!addType) {
      toast.error("Please select address type (Home, Work, or Other)");
      return;
    }
    const values = {
      Type: addType,
      Phone_Number: value.Phone_Number,
      Name: value.name,
      landmark: "-",
      Full_Address: value.address,
      House: value.housenumber,
      State: value.state,
      City: value.city,
      Pincode: value.pincode?.trim() || "",
    };
    const onSuccessCallback = () => {
      dispatch(geAddressApi(userToken));
      form.resetFields();
      setIsModalOpen(false);
      setIsEdit(false);
      setAddType("");
      setEditId("");
    };
    if (isEdit)
      dispatch(updateAddressApi(values, userToken, editId, onSuccessCallback));
    else dispatch(addAddressApi(values, userToken, onSuccessCallback));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setIsEdit(false);
    setAddType("");
    setEditId("");
  };

  const handleOkCoupon = (name, price, item) => {
    setCouponId(item?._id);
    setCouponName(name);
    setCouponPrice(price);
    setIsModalCoupon(false);
  };

  const TotalAmount = () => {
    return couponPrice
      ? Number(cartlist?.totalAmount) - Number(couponPrice)
      : Number(cartlist?.totalAmount);
  };

  const handleCouponCode = () => {
    dispatch(addCouponCodeApi({ couponCode }, () => {}, userToken));
  };

  const formatPrice = (price) =>
    Number(price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const handleSubmit = async () => {
    const addressId = Add?._id || addressList?.[0]?._id;
    if (!addressId) {
      toast.error("Please select delivery address");
      return;
    }
    const subtotalBeforeVat = TotalAmount();
    const vatAmount = vatSettings.isVatRegistered ? subtotalBeforeVat * (vatSettings.vatRate / 100) : 0;
    const payload = {
      Coupon: couponId || "",
      CouponPrice: couponPrice ? Number(couponPrice) : applyCoupon?.[0]?.discountAmount ? Number(applyCoupon[0].discountAmount) : 0,
      OriginalPrice: Number(cartlist?.totalOriginalAmount),
      DiscountPrice: Number(cartlist?.totalDiscount),
      Shipping_Charge: Number(cartlist?.ShippingCharge || 0),
      VAT_Amount: Number(vatAmount.toFixed(2)),
      VAT_Rate: vatSettings.isVatRegistered ? vatSettings.vatRate : 0,
      FinalPrice: Number((subtotalBeforeVat + vatAmount).toFixed(2)),
      Address: addressId,
      payment_mode: "COD",
      order_status: "Pending",
      reason: "",
    };
    dispatch(addOrderApi(payload, (res) => {
      toast.success(res.message);
      dispatch(setCartCount(0));
      navigate(routes.thankyouUrl, {
        state: {
          orderMongoId: res?.data?._id,
          orderId: res?.data?.orderId,
        },
      });
    }, userToken));
  };

  const cartItems = cartlist?.cartItems || [];

  return (
    <div className={styles.page}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb className={styles.breadcrumb} items={[
            { title: <Link to="/">Home</Link> },
            { title: <Link to="/cart">Cart</Link> },
            { title: "Checkout" },
          ]} />
        </div>
      </div>

      {/* Page Title */}
      <div className={styles.pageTitle}>
        <span className={styles.titleEyebrow}>The Diamond Counter</span>
        <h1 className={styles.titleText}>Checkout</h1>
        <div className={styles.titleLine} />
      </div>

      {/* Progress */}
      <div className={styles.progressBar}>
        <div className={styles.progressInner}>
          {["Cart", "Checkout", "Confirmation"].map((step, i) => (
            <React.Fragment key={step}>
              {i > 0 && <div className={`${styles.progressLine} ${i <= 1 ? styles.progressLineDone : ""}`} />}
              <div className={`${styles.progressStep} ${i < 1 ? styles.progressDone : ""} ${i === 1 ? styles.progressActive : ""}`}>
                <div className={styles.progressDot} />
                <span>{step}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.checkoutLayout}>
          {/* LEFT */}
          <div className={styles.leftColumn}>
            {/* Address */}
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <h3 className={styles.sectionTitle}>Delivery Address</h3>
                <button type="button" className={styles.addBtn} onClick={() => setIsModalOpen(true)}>+ Add New</button>
              </div>
              {addressList?.length > 0 ? (
                <div>
                  <AddressDropdown
                    items={addressList}
                    selectedIndex={indexSelect}
                    onSelect={(idx) => { setIndexSelect(idx); setAdd(addressList[idx]); }}
                    styles={styles}
                  />
                  {/* Selected address preview */}
                  {(() => {
                    const item = addressList[indexSelect];
                    if (!item) return null;
                    return (
                      <div className={styles.addressPreview}>
                        <div className={styles.addressPreviewTop}>
                          <span className={styles.addressType}>{item?.Type || "Other"}</span>
                          <span className={styles.addressName}>{item?.Name}</span>
                          {item?.Phone_Number && <span className={styles.addressPhone}>{item.Phone_Number}</span>}
                        </div>
                        <p className={styles.addressText}>
                          {item?.House}{item?.Full_Address && item.Full_Address !== "-" ? `, ${item.Full_Address}` : ""}, {item?.City}{item?.State ? `, ${item.State}` : ""}{item?.Pincode ? ` - ${item.Pincode}` : ""}
                        </p>
                        <div className={styles.addressActions}>
                          <button type="button" className={styles.addressEditBtn} onClick={() => handleAddressUpdate(item)}>
                            <EditTwoTone twoToneColor="#C5A028" /> Edit
                          </button>
                          <Popconfirm title="Delete this address?" onConfirm={() => handleAddreesRemove(item)} okText="Yes" cancelText="No">
                            <button type="button" className={styles.addressDeleteBtn}>
                              <DeleteTwoTone twoToneColor="red" /> Remove
                            </button>
                          </Popconfirm>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              ) : (
                <div className={styles.noAddress}><p>No saved addresses. Add one to continue.</p></div>
              )}
            </div>

            {/* Coupon */}
            <div className={styles.section}>
              <h3 className={styles.sectionTitle}>Coupon Code</h3>
              <div className={styles.couponSection}>
                <div className={styles.couponRow}>
                  <input type="text" placeholder="Enter coupon code" className={styles.couponInput} onChange={(e) => setCouponCode(e.target.value)} />
                  <button type="button" className={styles.couponApplyBtn} onClick={handleCouponCode} disabled={couponName || loaderCoupon}>
                    {loaderCoupon ? "..." : "Apply"}
                  </button>
                </div>
              {couponName && (
                <div className={styles.couponApplied}>
                  <span className={styles.couponTag}>{couponName}</span>
                  <button type="button" className={styles.couponRemove} onClick={() => { setCouponName(""); setCouponPrice(0); }}>Remove</button>
                </div>
              )}
                {couponListData?.length > 0 && !couponName && (
                  <button type="button" className={styles.exploreCoupons} onClick={() => setIsModalCoupon(true)}>Browse available coupons</button>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT: Summary */}
          <div className={styles.rightColumn}>
            <div className={styles.summaryCard}>
              <h3 className={styles.summaryCardTitle}>Order Summary</h3>
              <div className={styles.summaryItems}>
                {cartItems.map((item, index) => (
                  <div key={item?._id || index} className={styles.summaryItem}>
                    <div className={styles.summaryItemImg}>
                      <Image preview={false} src={item?.Variation?.image} alt={item?.Product?.product_Name} />
                    </div>
                    <div className={styles.summaryItemInfo}>
                      <p className={styles.summaryItemName}>{item?.Product?.product_Name}</p>
                      <div className={styles.summaryItemTags}>
                        {getVariantTags(item).map(([label, value]) => (
                          <span key={label} className={styles.summaryTag}>{label}: {value}</span>
                        ))}
                      </div>
                      <p className={styles.summaryItemQty}>Qty: {item?.Quantity}</p>
                    </div>
                    <div className={styles.summaryItemPrice}>{"\u00A3"}{formatPrice(item?.total || item?.price)}</div>
                  </div>
                ))}
              </div>

              <div className={styles.summaryTotals}>
                <div className={styles.summaryRow}><span>Subtotal</span><span>{"\u00A3"}{formatPrice(cartlist?.totalOriginalAmount)}</span></div>
                <div className={styles.summaryRow}><span>Shipping</span><span>{Number(cartlist?.ShippingCharge) > 0 ? `\u00A3${formatPrice(cartlist?.ShippingCharge)}` : "Free"}</span></div>
                {couponPrice > 0 && <div className={`${styles.summaryRow} ${styles.summaryDiscount}`}><span>Coupon</span><span>- {"\u00A3"}{formatPrice(couponPrice)}</span></div>}
                {vatSettings.isVatRegistered ? (() => {
                  const subtotal = TotalAmount();
                  const vatAmount = subtotal * (vatSettings.vatRate / 100);
                  return (
                    <>
                      <div className={styles.summaryDivider} />
                      <div className={styles.summaryRow}><span>Subtotal (ex. VAT)</span><span>{"\u00A3"}{formatPrice(subtotal)}</span></div>
                      <div className={styles.summaryRow}><span>VAT ({vatSettings.vatRate}%)</span><span>{"\u00A3"}{formatPrice(vatAmount)}</span></div>
                      <div className={styles.summaryDivider} />
                      <div className={`${styles.summaryRow} ${styles.summaryTotal}`}><span>Total (inc. VAT)</span><span>{"\u00A3"}{formatPrice(subtotal + vatAmount)}</span></div>
                    </>
                  );
                })() : (
                  <>
                    <div className={styles.summaryDivider} />
                    <div className={`${styles.summaryRow} ${styles.summaryTotal}`}><span>Total</span><span>{"\u00A3"}{formatPrice(TotalAmount())}</span></div>
                  </>
                )}
              </div>

              <button type="button" className={styles.placeOrderBtn} onClick={handleSubmit} disabled={isOrderLoading}>
                {isOrderLoading ? "Placing Order..." : "Place Order"}
              </button>

              <div className={styles.trustSignals}>
                {[
                  { icon: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />, label: "Secure" },
                  { icon: <><rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></>, label: "Insured" },
                  { icon: <><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></>, label: "Returns" },
                ].map((t, i) => (
                  <div key={i} className={styles.trustItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">{t.icon}</svg>
                    <span>{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Coupon Modal */}
      <Modal open={isModalCoupon} onCancel={() => setIsModalCoupon(false)} footer={null} title={null} centered className={styles.themedModal} zIndex={10001}>
        <h3 className={styles.modalTitle}>Available Coupons</h3>
        {couponListData?.length > 0 ? (
          <div className={styles.couponList}>
            {couponListData.map((item, index) => (
              <div key={index} className={styles.couponCard}>
                <div><span className={styles.couponCode}>{item?.couponCode}</span><span className={styles.couponDiscount}>Save {"\u00A3"}{item?.discountAmount}</span></div>
                <button type="button" className={styles.couponUseBtn} disabled={item?.usageCount >= item?.usageLimits} onClick={() => handleOkCoupon(item?.couponCode, item?.discountAmount, item)}>Apply</button>
              </div>
            ))}
          </div>
        ) : <p className={styles.noCoupons}>No coupons available.</p>}
      </Modal>

      {/* Address Modal */}
      <Modal open={isModalOpen} onCancel={handleCancel} footer={null} title={null} centered className={styles.themedModal} width={600} zIndex={10001}>
        <h3 className={styles.modalTitle}>{isEdit ? "Edit" : "Add"} Address</h3>
        <Form onFinish={handleAddressSubmit} form={form} name="address-form" autoComplete="off" layout="vertical" className={styles.addressForm}>
          <Form.Item name="name" rules={[{ required: true, message: "Required" }]}><Input placeholder="Full Name" className={styles.formInput} /></Form.Item>
          <Form.Item name="Phone_Number" rules={[{ required: true, message: "Required" }]}><Input type="number" placeholder="Phone Number" className={styles.formInput} /></Form.Item>
          <Form.Item name="housenumber" rules={[{ required: true, message: "Required" }]}><Input placeholder="House / Street / Area" className={styles.formInput} /></Form.Item>
          <Form.Item name="address" rules={[{ required: true, message: "Required" }]}><TextArea placeholder="Full Address" rows={3} className={styles.formInput} /></Form.Item>
          <div className={styles.formRow}>
            <Form.Item name="city" rules={[{ required: true, message: "Required" }]} style={{ flex: 1 }}><Input placeholder="City" className={styles.formInput} /></Form.Item>
            <Form.Item name="state" rules={[{ required: true, message: "Required" }]} style={{ flex: 1 }}><Input placeholder="County" className={styles.formInput} /></Form.Item>
            <Form.Item name="pincode" rules={[{ required: true, message: "Required" }]} style={{ flex: 1 }}><Input placeholder="Postcode" className={styles.formInput} /></Form.Item>
          </div>
          <div className={styles.addressTypeRow}>
            {["Home", "Work", "Other"].map((type) => (
              <button key={type} type="button" className={`${styles.addressTypeBtn} ${addType === type ? styles.addressTypeBtnActive : ""}`} onClick={() => setAddType(type)}>
                {type === "Home" && <HomeOutlined />}{type === "Work" && <InsertRowLeftOutlined />}{type === "Other" && <ProjectOutlined />} {type}
              </button>
            ))}
          </div>
          <Button
            htmlType="submit"
            className={styles.saveBtn}
            loading={loaderAddress}
            onClick={() => {
              form.validateFields().catch((err) => {
                console.log("Validation failed:", err);
              });
            }}
          >
            {isEdit ? "Update Address" : "Save Address"}
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default Summery;
